import { saveAs } from "file-saver";

export function saveAsCsv(data: string[][], filename: string) {
  const csv = data.map((line) => line.join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  saveAs(blob, filename);
}
